


















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import AuthModule from '@/store/AuthModule';
import { Component, Vue ,  Watch } from 'vue-property-decorator';
import Customer from '@/models/Customer';
import router from '@/router';
import formatCustomer from '@/utils/formatCustomer';
import {
  getCustomerPrescriber,
  postOptionPrescriber,
  postBookingPrescriber,
  patchBookingPrescriber,
    getKochise,
    getLotComparison,
    deleteDenouncePrescriberById
} from '@/api/api';
import get from 'lodash/get';
import Address from '@/models/Address';
import Denounce from '@/models/Denounce';
import moment from 'moment';
import { BACKEND_URL } from '@/helpers/constants';
import { buildDocumentUrl } from '@/helpers/document';
import { formatDenouceStatus } from '@/data/denouceStatus';
import { formatLotStatus, lotStatus } from '@/data/lot';
import { formatOptionStatus } from '@/data/optionStatus';
import { formatBookingStatus } from '@/data/bookingStatus';
import { formatProgramStatus } from '@/data/programStatus';
import { formatType } from '@/data/types';
import Lot from '@/models/Lot';
import User from '@/models/User';
import departments from '@/data/departments';
import FiltersModule from '@/store/FiltersModule';
import ListModule from '@/store/ListModule';
import {
  customerStatus,
  formatCustomerStatus,
  getFullCustomerStatus,
  customerStatusColors,
} from '@/data/customerStatus';
import { projects } from '@/data/denounceProjects';
import Program from '@/models/Program';
import Secret from '@/components/common/Secret.vue';
import { getTaxSystemValue } from '@/data/taxSystems';

import { saveAs } from 'file-saver';
import getOptionInfos from '../../utils/notifications';




let customer: Customer | null = null;

async function getCustomer(customerID: string) {
    try {
        const { data } = await getCustomerPrescriber(+customerID);
        return data;
    } catch (error) {
        //console.warn(error, get(error, 'response.data.message'));

        //router.push({ name: 'prospects' });
        return null;
    }
}

function getCustomerName(value: Customer | null) {
    if (value) {
        return formatCustomer(value);
    }
    return 'Prospect';
}

@Component({
    beforeRouteEnter: async (to, from, next) => {
        const { route } = router.resolve({
            name: 'prospects',
        });
        to.meta.breadcrumb[1].url = route.fullPath;

        customer = await getCustomer(to.params.customerID);

        if (customer == null) {
            Vue.prototype.$vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: `Prospect introuvable.`,
            });

            next({
                name: 'prospects',
            });
        } else {
            to.meta.breadcrumb[2].title = getCustomerName(customer);
            next();
        }
    },
    beforeRouteUpdate: async (to, from, next) => {
        customer = await getCustomer(to.params.customerID);
        to.meta.breadcrumb[2].title = getCustomerName(customer);

        next();
    },
    filters: {
        formatDate: (value: string) => {
            return value ? moment(value).format('L') : null;
        },
        formatCustomer,
        formatAddress(address: Address) {
            if (!address) {
                return '';
            }
            return `${address.city} (${address.postal_code})`;
        },
        date: (value: string) => {
            return moment(value).format('L');
        },
        euro: function (value: number) {
            return new Intl.NumberFormat('fr-FR', {
                style: 'currency',
                currency: 'EUR',
            }).format(value);
        },
        formatCustomerStatus,
        getFullCustomerStatus,
        formatDenouceStatus,
        formatLotStatus,
        formatOptionStatus,
        formatBookingStatus,
        formatDepartment(value: string) {
            const department = departments.find(d => d.code == value);
            return department
                ? `${department.name} (${department.code})`
                : value;
        },
        formatProgramStatus,
        formatType,
        getTaxSystemValue,
        formatQuarterDate(value: string, addOneQuarter: boolean) {
            const date = moment(value);
            if (addOneQuarter) {
                date.add(1, 'quarter');
            }
            date.startOf('quarter');

            return `${date.quarter()}T.${date.year()}`;
        },
        formatYMD: (value: string) => {
            let d = new Date(value);
            let mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d);
            let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
            return `(${da}-${mo})`;
        },
    },
    components: {
        Secret,
    },
})
export default class ProspectsDetails extends Vue {
    bookingFormType: string = '';
    downloaded: Boolean = false;
    BACKEND_URL = BACKEND_URL;

    planUrl(plan: any) {
        return buildDocumentUrl(this.BACKEND_URL, plan);
    }
    customer = customer;
    projects = projects;
    showBooking: Boolean = false;
    lotSelect!: Lot;
    showConfirmationPopup: Boolean = false;
    forceBooking: Boolean = false;
    showInfoPopup: Boolean = false;
    selectedDenounce: Denounce | null = null;
    showCommentsPopup: boolean = false;
    showSearchWarningPopup: boolean = false;

    showComparisonPopup: Boolean = false;

    simulationFrom: Object = {
        personnal_apport: null,
        credit_rate: null,
        credit_duration: null,
    }

    lotsSelected: Lot[] = [];



   denounceToDelete: any = null;
    showDeleteDenouncePopup: boolean = false;
    deletingDenounce: boolean = false;



    get firstname() {
            return AuthModule.firstname;
        }


    get lastname() {
        return AuthModule.lastname;
    }

    get logo() {
        return AuthModule.logo;
    }





    

    standardizedSecret(value: any) {
        // Store the original value in a data attribute that Secret won't use for asterisks
        return {
            length: 5,  // This will be used for asterisk count
            originalValue: value,  // This is the real value to display when shown
            toString() {
                return this.originalValue;  // Shows the original value when converted to string
            }
        };
    }

    // Then modify honoFormat
    honoFormat(hono: number, price: number) {
        const actualValue = Math.round(price * (hono/100)) + ' € HT/TTC soit '+ hono + '%HT/TTC';
        return this.standardizedSecret(actualValue);
    }

    getCommissionDisplay(tauxCommission: any): string {
        if (tauxCommission === null || tauxCommission === undefined || tauxCommission === '') {
            return 'NC';
        }

        const value = Number(tauxCommission);
        if (isNaN(value)) {
            return 'NC';
        }

        return `${value.toLocaleString('fr-FR', { maximumFractionDigits: 2 })}%`;
    }


    get isSubscribed() {
    return AuthModule.isSubscriptionActive;
            }

            get backendUrl() {
                return BACKEND_URL;
            }


    async displayItem(item: string, lot: Lot) {
        //@ts-ignore
        console.log(lot.item);
        //@ts-ignore
        return lot.item;
    }

    /*async displayKochise() {
        const $vs = (this as any).$vs;

        if(this.customer && this.customer.id) {
            if(this.customer.family_situation && this.customer.childrens_in_tax_home && this.customer.monthly_pay) {
                const { data } = await getKochise(this.customer.id);
                return data
            }
            return false
        }
    }*/

    async showComparison() {
        const $vs = (this as any).$vs;

        if(this.customer && this.customer.id) {
            if(this.customer.family_situation && this.customer.childrens_in_tax_home && this.customer.monthly_pay) {
                const req = {
                    lots: this.lotsSelected,
                    customer: this.customer,
                    other: this.simulationFrom
                }
                const { data } = await getKochise(req);
                return this.showComparisonPopup = true;
            }
            return $vs.notify({color:'danger',title:'Attention',text:'Afin de générer la comparaison des lots séléctionné vous devez remplir les champs Situtation familiale, enfants à charge et salaire mensuel.'})
        }
    }

    async getInfos(program: Program) {
        const $vs = (this as any).$vs;

        if(program) {
            let text = "<br><strong>Promoteur</strong> : " + program.promoter.name;
            if(program.date_delivery) {
                text += "<br><strong>Date de livraison</strong> : " + moment(program.date_delivery).format('L');
            }
            return $vs.notify({
                color: 'success',
                position: 'bottom-right',
                title: 'Infos denonce',
                text: text,
            });
        }
    }

    async showBookingPopup(lot: Lot) {
        const $vs = (this as any).$vs;

        if(AuthModule.isSubscriptionActive !== true && AuthModule.isTrialActive !== true) {
            this.$router.push({
                name: 'subscription'
            });

            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Attention',
                text: `Un abonnement est requis pour accèder à ces fonctionnalités`,
            });

            return;
        }
        this.lotSelect = lot;
        this.showBooking = true;
    }

    async selectLot(lot: Lot) {
        let index: number = this.lotsSelected.indexOf(lot);
        if (index === -1) {
            this.lotsSelected.push(lot);
        } else {
            this.lotsSelected.splice(index, 1);
        }
    }

  

    getColorStatusDenounce(status: string) {
        switch (status) {
            case 'accepted':
                return 'success';
            case 'refused':
                return 'danger';
            case 'pending':
                return 'warning';
            case 'canceled':
                return 'danger';
        }
        return 'primary';
    }
    getColorStatusOption(status: string) {
        switch (status) {
            case 'accepted':
                return 'success';
            case 'refused':
                return 'danger';
            case 'pending':
                return 'warning';
        }
        return 'primary';
    }

    get optionsArray() {
        if (!this.customer || !this.customer.options) {
            return [];
        }
        return this.customer.options.map(item => item.lot && item.lot.id);
    }

    get selectedDenounceOptionComments(): { lotId: number; lotName: string; comment: string; updatedAt?: string }[] {
        if (!this.selectedDenounce || !this.selectedDenounce.lots || !this.customer || !this.customer.options) {
            return [];
        }
        //@ts-ignore
        const lotIds = this.selectedDenounce.lots.map((lot: any) => lot.id);
        return this.customer.options
            .filter((option: any) => option.lot && lotIds.includes(option.lot.id) && option.delete_comments)
            .map((option: any) => ({
                lotId: option.lot.id,
                lotName: option.lot.name,
                comment: option.delete_comments,
                updatedAt: option.updated_at,
            }));
    }

    get getOptionInfos() {
        return getOptionInfos;
    }

    get bookingArray() {
        if (!this.customer || !this.customer.bookings) {
            return [];
        }
        return this.customer.bookings.map(item => item.lot && item.lot.id);
    }

    get departments() {
        return departments;
    }

    getProjectDenounce(project: any): any {
        return this.projects[project];
    }

    optionStatus(lotID: number): string {
        if (!this.customer || !this.customer.options) {
            return '';
        }
        const { options } = this.customer;

        const option = options.find(item => {
            if (item.lot) {
                return item.lot.id === lotID;
            }
            return false;
        });

        return option ? option.status || '' : '';
    }

    optionUpdate(lotID: number): string {
        if (!this.customer || !this.customer.options) {
            return '';
        }
        const { options } = this.customer;

        const option = options.find(item => {
            if (item.lot) {
                return item.lot.id === lotID;
            }
            return false;
        });

        return option ? option.updated_at || '' : '';
    }

    optionEndAt(lotID: number): string {
      if (!this.customer || !this.customer.options) {
        return '';
      }
      const { options } = this.customer;

      const option = options.find(item => {
        if (item.lot) {
          return item.lot.id === lotID;
        }
        return false;
      });

    return option ? option.end_at || '' : '';
  }


  bookingStatus(lotID: number): string {
        if (!this.customer || !this.customer.bookings) {
            return '';
        }

        // filter out any booking whose status is 'cancelled' or whose lot is missing
        const active = this.customer.bookings.filter((b) => {
            return b.lot && b.lot.id === lotID && b.status !== 'cancelled';
        });

        if (active.length > 0) {
            return active[0].status || '';
        }

        return '';
        }


    bookingUpdate(lotID: number): string {
        if (!this.customer || !this.customer.bookings) {
            return '';
        }
        const { bookings } = this.customer;

        const booking = bookings.find(item => {
            if (item.lot) {
                return item.lot.id === lotID;
            }
            return false;
        });

        return booking ? booking.updated_at || '' : '';
    }


    canReserve(lotID: number): boolean {
    const opt = this.optionStatus(lotID);
    const book = this.bookingStatus(lotID);
    return opt === 'accepted' && book === '';
    }

    proceedWithBookingAnyway() {
    console.log("proceedWithBookingAnyway appelé");
    this.forceBooking = true;
    console.log("forceBooking mise à jour:", this.forceBooking);
    this.showConfirmationPopup = false;
    
    if (!this.customer) {
        console.log("Customer est null, on arrête");
        return;
    }
    
    if (this.bookingFormType == 'plugimmo') {
        this.postBooking(this.customer);
    } else if (this.bookingFormType == 'self') {
        this.postBookingWithSelfForm(this.customer);
    }
    }

    // Ajouter cette méthode de gestion des erreurs
    handleBookingError(error: any, customer: Customer) {
        console.log("handleBookingError appelé");
        const $vs = (this as any).$vs;
        const resp = error.response;
        
        // Affichage sécurisé sans opérateur de chaînage
        console.log("Réponse d'erreur:", resp && resp.data ? resp.data.message : "Pas de message");
        
        if (resp && resp.data && resp.data.message &&
            resp.data.message.includes("une réservation en cours") &&
            !this.forceBooking) {
            
            console.log("Affichage popup, forceBooking =", this.forceBooking);
            this.showConfirmationPopup = true;
            return;
        }
    
    // Pour les autres erreurs, comportement normal
    let message;
    if (resp && resp.data && typeof resp.data.message === 'string') {
        message = resp.data.message;
    } else if (resp) {
        message = `Erreur ${resp.status} lors de la réservation.`;
    } else {
        message = 'Erreur réseau ou serveur indisponible.';
    }

    $vs.notify({
        color: 'danger',
        position: 'top-right',
        title: 'Réservation échouée',
        text: message
    });
    
    // Ajouter une vérification pour customer et customer.id
    if (customer && customer.id) {
        this.$router.push({
        name: 'editProspect',
        params: { customerID: customer.id.toString() },
        query: { errorMsg: message }
        });
    }
    }

    async postOption(lot: Lot, denounce: Denounce, onAvailable: boolean|null) {
        const $vs = (this as any).$vs;

        if (!lot.id || !denounce.id) {
            return;
        }
        try {
            if (!this.customer || !this.customer.options) {
                throw new Error('Prospect or options can not be null.');
            }
            const { data } = await postOptionPrescriber(lot.id, denounce.id);
            if(!onAvailable) {
                this.customer.options.push(data);
                console.log(lot);

                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Modification',
                    text: `L'option à bien été posée`,
                });
            } else {
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Modification',
                    text: `Votre demande à été prise en compte, vous recevrez un mail si le lot redevient disponible.`,
                });
            }
        } catch (error) {
            const message = get(
                error,
                'response.data.errors.children.lot.errors[0]',
                'Une erreur est survenue'
            );
            
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        }
    }

    async postBookingWithSelfForm(customer: Customer) {
        const $vs = (this as any).$vs;
        var lot = this.lotSelect;
        this.showBooking = false;
        
        if (!lot.id || !customer.id) {
            return;
        }
        try {
            if (!this.customer || !this.customer.bookings) {
            throw new Error('Prospect or bookings can not be null.');
            }
            console.log("postBookingWithSelfForm: Avant appel API, forceBooking =", this.forceBooking);
            console.log("postBookingWithSelfForm: Force directe =", !!this.forceBooking);
            const { data } = await postBookingPrescriber(lot.id, customer.id, !!this.forceBooking);
            //@ts-ignore
            let id: number = data.id;
            await patchBookingPrescriber(id, {
            self_filled_form: true,
            progression: 'signature',
            });
            this.customer.bookings.push(data);

            this.$router.push({
            name: 'bookingPrescriber',
            params: {
                bookingID: id.toString(),
            }
            });

            $vs.notify({
            color: 'success',
            position: 'top-right',
            title: 'Modification',
            text: `La réservation a bien été posée`,
            });
        } 
        catch (error) {
            this.handleBookingError(error, customer);
        }
        }


    async postBooking(customer: Customer) {
        const $vs = (this as any).$vs;

        if(AuthModule.isSubscriptionActive !== true && AuthModule.isTrialActive !== true) {
            this.$router.push({
            name: 'subscription'
            });

            $vs.notify({
            color: 'danger',
            position: 'top-right',
            title: 'Attention',
            text: `Un abonnement est requis pour accéder à ces fonctionnalités`,
            });

            return;
        }

        var lot = this.lotSelect;
        this.showBooking = false;
        
        if (!lot.id || !customer.id) {
            return;
        }
        
        try {
            if (!this.customer || !this.customer.bookings) {
            throw new Error('Prospect or bookings can not be null.');
            }
            
            // Utiliser le paramètre forceBooking pour indiquer si on veut forcer
            console.log("postBooking: Avant appel API, forceBooking =", this.forceBooking);
            console.log("postBooking: Force directe =", !!this.forceBooking);
            const { data } = await postBookingPrescriber(lot.id, customer.id, !!this.forceBooking);
            this.customer.bookings.push(data);
            //@ts-ignore
            let id: number = data.id;
            this.$router.push({
            name: 'bookingPrescriber',
            params: {
                bookingID: id.toString(),
            }
            });

            $vs.notify({
            color: 'success',
            position: 'top-right',
            title: 'Modification',
            text: `La réservation a bien été posée`,
            });
        } 
        catch (error) {
            this.handleBookingError(error, customer);
        }
        }


    loadSavedSearch() {
        if (!this.customer || !this.customer.search) {
            return;
        }

        if (!this.lotsSelected || this.lotsSelected.length === 0) {
            this.showSearchWarningPopup = true;
            return;
        }

        this.executeLoadSavedSearch();
    }

    executeLoadSavedSearch() {
        if (!this.customer || !this.customer.search) {
            return;
        }

        const {
            program_status,
            program,
            promoter,
            lot_price_min,
            lot_price_max,
            program_tax_system,
            lot_type,
            lot_type2,
            departments,
            city,
            program_delivery_date_min,
            program_delivery_date_max,
            region,
        } = this.customer.search;

        const now = moment();
        const minDate = moment(program_delivery_date_min);
        const maxDate = moment(program_delivery_date_max);
        maxDate.subtract(1, 'quarter');

        FiltersModule.setFilters({
            ...FiltersModule.filters,
            status: program_status ? program_status : '',
            program: program ? program.name : undefined,
            promotor: promoter ? promoter.name : undefined,
            dateInterval: [
                (minDate.year() - now.year()) *
                4 *
                FiltersModule.filters.timeStep +
                minDate.quarter() * FiltersModule.filters.timeStep,
                (maxDate.year() - now.year()) *
                4 *
                FiltersModule.filters.timeStep +
                maxDate.quarter() * FiltersModule.filters.timeStep,
            ],
            budget: {
                min: lot_price_min ? lot_price_min : null,
                max: lot_price_max ? lot_price_max : null,
            },
            taxes: program_tax_system ? program_tax_system : [],
            types: lot_type ? lot_type : [],
            types2: lot_type2 ? lot_type2 : [],
            departement:
                departments && departments.length > 0
                    ? departments[0]
                    : undefined,
            city: city ? city : undefined,
        });

        if (this.lotsSelected && this.lotsSelected.length > 0) {
            const selectedLotIds: number[] = this.lotsSelected.map((lot: any) => lot.id).filter(Boolean);
            const denounceSelectedProgramIds: number[] = [];
            const denounceSelectedMarkers: any[] = [];

            if (this.customer.denounces && this.customer.denounces.length > 0) {
                this.customer.denounces.forEach((denounce: any) => {
                    if (denounce.program && denounce.program.id && denounce.lots && denounce.lots.length > 0) {
                        const hasSelectedLot = denounce.lots.some((lot: any) => selectedLotIds.includes(lot.id));
                        if (hasSelectedLot && !denounceSelectedProgramIds.includes(denounce.program.id)) {
                            denounceSelectedProgramIds.push(denounce.program.id);
                            const addr = denounce.program.address;
                            if (addr && addr.latitude && addr.longitude) {
                                denounceSelectedMarkers.push({
                                    programID: denounce.program.id,
                                    coordinates: { lat: addr.latitude, lng: addr.longitude },
                                    color: '#1a1a1a',
                                });
                            }
                        }
                    }
                });
            }

            localStorage.setItem('denounce_selected_program_ids', JSON.stringify(denounceSelectedProgramIds));
            localStorage.setItem('denounce_selected_lot_ids', JSON.stringify(selectedLotIds));
            localStorage.setItem('denounce_selected_program_markers', JSON.stringify(denounceSelectedMarkers));
            sessionStorage.setItem('denounce_session_active', '1');
        } else {
            localStorage.removeItem('denounce_selected_program_ids');
            localStorage.removeItem('denounce_selected_lot_ids');
            localStorage.removeItem('denounce_selected_program_markers');
            sessionStorage.removeItem('denounce_session_active');
        }

        this.$router.push({ name: 'homePrescriber' });
    }


    // Copy address functionality
            copyAddress(program: any): void {
                if (program && program.address) {
                    const { street, postal_code, city } = program.address;
                    const fullAddress: string = `${street} ${postal_code} ${city}`;
                    
                    // Try modern API first
                    if ((navigator as any).clipboard && (window as any).isSecureContext) {
                        (navigator as any).clipboard.writeText(fullAddress)
                            .then(() => {
                                this.showSuccessMessage();
                            })
                            .catch((err: any) => {
                                console.warn('API Clipboard failed:', err);
                                this.oldMethodCopy(fullAddress);
                            });
                    } else {
                        // Use old method directly
                        this.oldMethodCopy(fullAddress);
                    }
                }
            }

            // Old method with legacy API
            oldMethodCopy(text: string): void {
                const input: HTMLInputElement = document.createElement('input');
                input.value = text;
                input.style.position = 'fixed';
                input.style.top = '-9999px';
                input.style.opacity = '0';
                
                document.body.appendChild(input);
                input.select();
                
                let copied: boolean = false;
                try {
                    copied = document.execCommand('copy');
                } catch (e) {
                    console.error('Copy error:', e);
                }

                document.body.removeChild(input);
                
                if (copied) {
                    this.showSuccessMessage();
                } else {
                    this.showErrorMessage();
                }
            }

            showSuccessMessage(): void {
                const $vs: any = (this as any).$vs;
                if ($vs && $vs.notify) {
                    $vs.notify({
                        color: 'success',
                        position: 'top-right',
                        title: 'Copié',
                        text: 'Adresse copiée dans le presse-papier',
                    });
                }
            }

            showErrorMessage(): void {
                const $vs: any = (this as any).$vs;
                if ($vs && $vs.notify) {
                    $vs.notify({
                        color: 'danger',
                        position: 'top-right',
                        title: 'Erreur',
                        text: 'Impossible de copier l\'adresse automatiquement',
                    });
                }
            }





    getStatusChipClass(status: string | undefined) {
            switch (status) {
                case 'accepted':
                    return 'success';
                case 'refused':
                    return 'danger';
                case 'pending':
                    return 'warning';
                case 'canceled':
                    return 'danger';
                default:
                    return 'primary';
            }
        }
        
        getOptionStatusClass(status: string) {
            switch (status) {
                case 'accepted':
                    return 'success';
                case 'refused':
                    return 'danger';
                case 'pending':
                    return 'warning';
                default:
                    return 'primary';
            }
        }
        
        getBookingStatusClass(status: string) {
            switch (status) {
                case 'accepted':
                    return 'success';
                case 'refused':
                    return 'danger';
                case 'pending':
                    return 'warning';
                default:
                    return 'primary';
            }
        }




        localPrivateMode: boolean = false;




        // ************************************************************************
        showTrialPopup: boolean = false;
        canvasAnimationId: number = 0;

        // Getters à ajouter
        get isTrial() {
            return AuthModule.isTrialActive;
        }

        get businessDevelopper() {
            return AuthModule.business_developper;
        }

        // Remplacer toggleLocalPrivateMode existant
        toggleLocalPrivateMode() {
            if (this.isTrial) {
                if (this.localPrivateMode) {
                    return;
                }
                this.showTrialPopup = true;
                return;
            }
            this.localPrivateMode = !this.localPrivateMode;
        }

        // Ajouter ces méthodes
        closePopup() {
            this.showTrialPopup = false;
            if (this.canvasAnimationId) {
                cancelAnimationFrame(this.canvasAnimationId);
            }
        }

        @Watch('showTrialPopup')
        onShowTrialPopupChange(val: boolean) {
            if (val) {
                this.$nextTick(() => { this.initCanvas(); });
            }
        }

        initCanvas() {
            const canvas = this.$refs.trialCanvas as HTMLCanvasElement;
            if (!canvas) return;
            const ctx = canvas.getContext('2d');
            if (!ctx) return;
            canvas.width = canvas.offsetWidth;
            canvas.height = canvas.offsetHeight;
            const particles: any[] = [];
            for (let i = 0; i < 40; i++) {
                particles.push({
                    x: Math.random() * canvas.width,
                    y: Math.random() * canvas.height,
                    radius: Math.random() * 2 + 0.5,
                    vx: Math.random() * 0.4 - 0.2,
                    vy: Math.random() * 0.4 - 0.2,
                    alpha: Math.random() * 0.5 + 0.1
                });
            }
            const draw = () => {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                particles.forEach(p => {
                    p.x += p.vx; p.y += p.vy;
                    if (p.x < 0 || p.x > canvas.width) p.vx *= -1;
                    if (p.y < 0 || p.y > canvas.height) p.vy *= -1;
                    ctx.beginPath();
                    ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
                    ctx.fillStyle = `rgba(255, 255, 255, ${p.alpha})`;
                    ctx.fill();
                });
                this.canvasAnimationId = requestAnimationFrame(draw);
            };
            draw();
        }


        get groupedComments(): Array<{ comment: string; denounces: any[] }> {
            if (!this.customer || !this.customer.denounces) return [];
            const withComments = (this.customer.denounces as any[]).filter(
                (d: any) => d.message_text && d.message_text.trim()
            );
            const map = new Map<string, any[]>();
            withComments.forEach((d: any) => {
                const key = d.message_text.trim();
                if (!map.has(key)) map.set(key, []);
                map.get(key)!.push(d);
            });
            return Array.from(map.entries()).map(([comment, denounces]) => ({ comment, denounces }));
        }

        get allLots(): Lot[] {
            if (!this.customer || !this.customer.denounces) return [];
            let lots: Lot[] = [];
            this.customer.denounces.forEach((d: any) => {
                if (d.lots) lots = lots.concat(d.lots);
            });
            return lots;
        }


        get isAllSelected(): boolean {
            const total = this.allLots.length;
            return total > 0 && this.lotsSelected.length === total;
        }



        toggleSelectAll() {
            if (this.isAllSelected) {
                this.lotsSelected = [];
            } else {
                this.lotsSelected = [...this.allLots];
            }
        }



            canDeleteDenounce(denounce: any): boolean {
                if (!denounce.lots || denounce.lots.length === 0) return false;
                for (const lot of denounce.lots) {
                    if (this.optionsArray.includes(lot.id)) return false;
                    if (this.bookingArray.includes(lot.id)) return false;
                }
                return true;
            }



            async deleteDenounce(denounce: any) {
                const $vs = (this as any).$vs;

                if (!denounce.id || !this.customer) return;

                this.denounceToDelete = denounce;
                this.showDeleteDenouncePopup = true;
            }





            async confirmDeleteDenounce() {
                    if (!this.denounceToDelete) return;
                    const denounce = this.denounceToDelete;
                    this.deletingDenounce = true;
                    const $vs = (this as any).$vs;

                    try {
                        await deleteDenouncePrescriberById(denounce.id);

                        if (this.customer && this.customer.denounces) {
                            const index = this.customer.denounces.indexOf(denounce);
                            if (index !== -1) {
                                this.customer.denounces.splice(index, 1);
                            }
                        }

                        $vs.notify({
                            color: 'success',
                            position: 'top-right',
                            title: 'Succes',
                            text: 'La denonce a bien ete supprimee',
                        });
                    } catch (error) {
                        $vs.notify({
                            color: 'danger',
                            position: 'top-right',
                            title: 'Erreur',
                            text: 'Une erreur est survenue lors de la suppression',
                        });
                    } finally {
                        this.deletingDenounce = false;
                        this.showDeleteDenouncePopup = false;
                        this.denounceToDelete = null;
                    }
                }






    // ============================================

    canDeleteLot(lot: Lot): boolean {
            return !this.optionsArray.includes(lot.id) && !this.bookingArray.includes(lot.id);
        }




    // ============================== Export Data Btn   ============================================

    showExportProgressPopup: Boolean = false;
    exportProgressError: Boolean = false;
    exportProgressMessage: string = '';



    async exportPdfLots() {
        let lots: any[] = [];

        if(this.customer) {
            lots.push(`${this.customer.civility} ${this.customer.first_lastname} ${this.customer.first_firstname}`);
        }

        this.lotsSelected.forEach(el => {
            // @ts-ignore
            lots.push(el.id);
        });

        const $vs = (this as any).$vs;

        this.exportProgressError = false;
        this.exportProgressMessage = '';
        this.showExportProgressPopup = true;

        try {
            // @ts-ignore
            const resp: any = await getLotComparison(lots);

            const fileName = resp.headers['content-disposition']
                ? resp.headers['content-disposition'].split('"')[1]
                : `comparaison_lots.pdf`;

            try {
                saveAs(resp.data, fileName);
                this.showExportProgressPopup = false;
            } catch (e) {
                this.exportProgressError = true;
                this.exportProgressMessage = 'Le fichier a ete genere mais n\'a pas pu etre telecharge.';
            }
        } catch (error) {
            this.exportProgressError = true;

            const err = error as any;
            const status = err && err.response && err.response.status;
            const responseData = err && err.response && err.response.data;

            if (status === 404) {
                const message = (typeof responseData === 'string' ? responseData : '') ||
                    (responseData && responseData.message) || '';

                if (message.toLowerCase().includes('program') || message.toLowerCase().includes('programme')) {
                    this.exportProgressMessage = 'Le programme associe a un ou plusieurs lots n\'est plus disponible. Veuillez verifier vos selections.';
                } else if (message.toLowerCase().includes('lot')) {
                    this.exportProgressMessage = 'Un ou plusieurs lots selectionnes ne sont plus disponibles dans la base de donnees.';
                } else if (message.toLowerCase().includes('document') || message.toLowerCase().includes('fichier')) {
                    this.exportProgressMessage = 'Les documents commerciaux de ce programme ne sont pas encore disponibles.';
                } else {
                    this.exportProgressMessage = 'Une ressource necessaire a la generation du document est introuvable (programme, lot ou document commercial manquant).';
                }
            } else if (status === 422) {
                this.exportProgressMessage = 'Certains lots selectionnes ont des donnees incompletes. Veuillez verifier les informations manquantes.';
            } else if (status === 500) {
                this.exportProgressMessage = 'Le serveur n\'a pas pu generer le document. Il est possible que des documents commerciaux soient manquants pour ce programme.';
            } else {
                this.exportProgressMessage = 'Une erreur est survenue lors de la generation du PDF. Verifiez que tous les lots selectionnes ont leurs documents disponibles.';
            }
        }
    }




    openProgramInTab(program: any) {
        const programId = program.id;
        const programName = program.name || `Programme N° ${program.id}`;

        if (this.$route.name === 'homePrescriber') {
            this.$root.$emit('openProgramTab', programId, programName);
        } else {
            this.$router.push({ name: 'homePrescriber' });
            setTimeout(() => {
                this.$root.$emit('openProgramTab', programId, programName);
            }, 300);
        }
    }






}




